import { render, staticRenderFns } from "./Shareshop.vue?vue&type=template&id=decbc920&"
import script from "./Shareshop.vue?vue&type=script&lang=js&"
export * from "./Shareshop.vue?vue&type=script&lang=js&"
import style0 from "./Shareshop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports